import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { ContratacaoRotaInteligenteService } from 'src/app/services/contratacao-rota-inteligente.service';
import { LoadingGenericoComponent } from '../../../components/loading-generico/loading-generico.component';
import { AlertConfirmacaoContratacaoRotaComponent } from '../../../components/alert-confirmacao-contratacao-rota/alert-confirmacao-contratacao-rota.component';
import { HeaderComponent } from '../../../components/header/header.component';
import { BotaoChatComponent } from '../../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../../components/breadcrumb/breadcrumb.component';
import { FormsModule } from '@angular/forms';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { RouterLink } from '@angular/router';
import { NgClass, AsyncPipe, CurrencyPipe } from '@angular/common';
import { FooterComponent } from '../../../components/footer/footer.component';
import { UsuarioPermissaoPipe } from '../../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-contratacao-plano-mensal',
    templateUrl: './contratacao-plano-mensal.component.html',
    styleUrls: ['./contratacao-plano-mensal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, AlertConfirmacaoContratacaoRotaComponent, HeaderComponent, BotaoChatComponent, BreadcrumbComponent, FormsModule, PopoverDirective, RouterLink, NgClass, FooterComponent, AsyncPipe, CurrencyPipe, UsuarioPermissaoPipe]
})
export class ContratacaoPlanoMensalComponent implements OnInit {

  public loadingGenerico: boolean = false;
  public showalertConfirmacaoContratacaoRota: boolean = false;

  public checkBox: boolean = false;

  public resources: any;

  public empresa: any = localStorage.idEmpresaLogada;

  public consultaSelecionada: any;
  public consultaEnviada: any;

  public consultaMensal: boolean = false;

  public checkPlanoStatus: boolean = false;
  public tituloContratacao: any;
  public isMatriz: boolean = false;
  public checkPlanoFiliais: boolean = false;

  constructor(
    private readonly contratacaoRotaInteligenteService: ContratacaoRotaInteligenteService,
    private readonly Toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.getPlanoMensal();
  }

  public getPlanoMensal() {
    this.loadingGenerico = true;
    this.contratacaoRotaInteligenteService.getAllPlanos(this.empresa)
    .pipe(take(1))
    .subscribe({
      next: (success: any) => {
          this.loadingGenerico = false;
          this.resources = success.response.listaFaixas;
          this.isMatriz = success.response.isMatriz

          for (const resource of this.resources) {
            if (resource.erroPedido) {
              resource.statusFinanceiro = resource.qtdeMaxRoteirizacoesMes;
            }
            if (resource.qtdeMaxRoteirizacoesMes == 1) {
              resource.tituloContratacao = 'Consulta';
            }
            else {
              resource.tituloContratacao = 'Consultas';
            }
          }
      },
      error: (error: any) => {
          this.loadingGenerico = false;
          this.Toastr.error('Erro ao fazer requisição')
      }
    });
  }

  public planoFiliais() {
    this.checkPlanoFiliais = !this.checkPlanoFiliais;
  }


  public eventoAlertConfirmacaoContratacaoRota(evento: any) {
    this.showalertConfirmacaoContratacaoRota = evento;
  }

  public checkPlano(evento: any) {
    this.checkPlanoStatus = evento;
  }

  public AlertConfirmacaoContratacaoRota() {
    if (this.checkBox === true) {
      this.consultaEnviada = this.consultaSelecionada
      this.showalertConfirmacaoContratacaoRota = true;
      this.consultaMensal = true;
    }

    else {
      this.Toastr.error('Selecione um Plano')
    }
  }

  public eventoConfirmacaoContratacaoRotaFechou(event: any) {
    this.showalertConfirmacaoContratacaoRota = event;
  }

  cardClick(empresa) {
    this.checkBox = true;
    this.consultaSelecionada = empresa
  }
}
